module.exports = __webpack_public_path__ + "static/media/forward-icon-light.c87bbf43.svg";